<template>
    <div class="test_exam">
        <div v-if="testStep == 1">
            <div class="test_top">考试</div>
            <div class="test_content" v-if="testList.length">
                <div class="test_content_one" v-for="(item, index) in testList" :key="index">
                    <div class="test_title flex Flexalign FlexBetween">
                        <!-- <div>【{{ item.chapterNum }}】</div> -->
                        <div>{{ item.chapterName }}</div>
                        <div class="btn_test cursor_pointer" @click="testChapterBegin(item)" v-if="item.examId">开始测验</div>
                    </div>
                    <div v-for="(sitem, sindex) in item.subExamList" :key="sindex">
                        <div class="test_info flex Flexalign FlexBetween">
                            <div class="test_info_left flex Flexalign">
                                <div class="cursor_pointer" v-if="!sitem.showDetail"
                                    @click="changeDetailShow(sitem, true)">
                                    <el-icon color="RGBA(162, 162, 162, 1)" :size="18">
                                        <ArrowDown />
                                    </el-icon>
                                </div>
                                <div class="cursor_pointer" v-else @click="changeDetailShow(sitem, false)">
                                    <el-icon color="RGBA(162, 162, 162, 1)" :size="18">
                                        <ArrowUp />
                                    </el-icon>
                                </div>
                                <div class="test_name">章节测试-{{ sitem.chapterName }}</div>
                                <!-- <div class="test_deadline">截止时间：{{ sitem.deadline }}</div> -->
                            </div>
                            <div class="test_info_right flex Flexalign">
                                <div class="test_score" v-if="sitem.isTest">得分：<span class="score_value">{{
                                    sitem.score }}</span>分
                                </div>
                                <div class="btn_test cursor_pointer" v-if="sitem.examId" @click="testBegin(sitem)">开始测验</div>
                            </div>
                        </div>
                        <div class="test_detail" v-if="sitem.showDetail">
                            <div class="test_score_info">
                                共{{ sitem.fullScore }}分
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="test_content flex flexcolumn Flexjustify" v-else>
                <moe-empty url="moe_empty_bg_img.png" emptyText="暂无考试" ></moe-empty>
            </div>
        </div>
        <div v-if="testStep == 2">
            <div class="test_top test_top2 flex Flexalign FlexBetween">
                <div>章节测试-{{ examInfo.examName }}</div>
                <div class="flex Flexalign cursor_pointer" @click="goStep(1)">
                    <el-image class="back_icon" :src="iconPath('back_icon.png')"></el-image>
                    <div class="back_text">返回</div>
                </div>
            </div>
            <div class="test_info">
                <div>1. 可尝试次数：<span class="active_text">{{ examInfo.retakeTimes }} 次，取最高得分作为最终成绩</span></div>
                <div>2. 测验时间：<span class="active_text">{{ examInfo.answerTime }} 分钟</span></div>
            </div>
            <div class="attention_box">
                <div class="attention_text">请您认真阅读以下注意事项，再开始考试</div>
                <div class="attention_text">1.在电脑端进行考试，推荐使用最新版谷歌浏览器；</div>
                <div class="attention_text">2.答题时请关闭聊天工具、视频等其他无关的软件、工具、插件，避免影响您本次答题；</div>
                <div class="attention_text">
                    3.如果本场考试开启了防作弊功能，以下几种操作都会占用切屏次数：F5刷屏，Alt+tab切换页面、Esc退出全屏、Alt+F4关闭当前页面、唤起文件夹、点击超链接进行跳转；</div>
                <div class="attention_text">4.需要一次性作答并提交，答题过程中不要切换或关闭页面，一旦开启考试，倒计时将不会停止；</div>
            </div>
            <div class="agree_box flex Flexalign">
                <el-image class="select_none_icon cursor_pointer" :src="iconPath('select_none_icon.png')"
                    v-if="!agreeFlag" @click="changeAgreeFlag(true)"></el-image>
                <el-image class="select_none_icon cursor_pointer" :src="iconPath('selected_icon.png')" v-else
                    @click="changeAgreeFlag(false)"></el-image>
                <div>依照学术诚信条款，我保证本测验答案是我独立完成的</div>
            </div>
            <div class="btn_test cursor_pointer mar_top_10" @click="goStep(3)">开始测验</div>
        </div>
        <testPaper :examInfo="examInfo" v-if="testStep == 3" @backStep="goStep"></testPaper>
    </div>
</template>

<script>
import testPaper from './testPaper.vue';
export default {
    name: 'GjkcH5TestExam',
    props: {
        courseDetail: {}
    },
    components: {
        testPaper
    },

    data() {
        return {
            testStep: 1,
            testList: [],
            agreeFlag: false,
            examInfo: {}
        };
    },

    mounted() {
        this.getCourseTestList();
    },

    methods: {
        goStep(value) {
            if (value == 3) {
                if (!this.agreeFlag) {
                    this.$Dialog.toast('请先同意以上条款', { type: 'warning' });
                    return
                }
            }
            this.testStep = value;
            this.$emit('changeStep', value);
        },
        changeDetailShow(info, flag) {
            info.showDetail = flag;
        },
        changeAgreeFlag(flag) {
            this.agreeFlag = flag;
        },
        // 获取章节测试列表
        getCourseTestList() {
            this.$Api.exam.getChapterExamList(this.courseDetail.courseId).then(res => {
                let list = res.data.data;
                // 处理列表（将章节存放至对应目录下）
                this.handleChapter(list);
            }).catch(() => { })
        },
        // 处理列表（将章节存放至对应目录下）
        handleChapter(list) {
            let handleList = [];
            // 筛选出没有父节点（parentId为0）的作为目录后将对应的父节点下的归类到subExamList中
            // list.forEach(item => {
            //     if (item.parentId == 0) {
            //         handleList.push({ ...item, subExamList: [], showDetail: false });
            //     }
            // });
            // for (let i = 0; i < list.length; i++) {
            //     for (let j = 0; j < handleList.length; j++) {
            //         if (list[i].parentId == handleList[j].chapterId) {
            //             handleList[j].subExamList.push({ ...list[i], showDetail: false });
            //         }
            //     }
            // }
            handleList = this.$Tree.handleTree(list, "chapterId", "parentId");
      this.traverseArray(handleList);
            this.testList = handleList;
        },
         // 递归数组
    traverseArray(array) {
      array.forEach((item) => {
        item.showDetail = false;
        if (item.children?.length) {
          // 如果当前项有children，则递归调用该函数
          this.traverseArray(item.children);
        }
      });
    },
        // 开始测验(章节)
        testBegin(info) {
            // 提交次数
            if (info.submitCount != 0) {
                // 不允许重考
                if (info.allowRetake == 0) {
                    this.$Dialog.toast('当前章节不允许重考', { type: 'warning' });
                    return
                } else {
                    //没有达到最大提交次数 ture:没有达到 false：已达到
                    if (!info.noSubmitCount) {
                        this.$Dialog.toast('已经达到最大提交次数', { type: 'warning' });
                        return
                    }
                }
            }

            this.$Api.exam.getChapterExamByExamId(info.chapterType, info.examId).then(res => {
                this.examInfo = res.data.data;
                this.testStep = 2;
            }).catch(() => { })
        },
        // 开始测验（目录）
        testChapterBegin(info) {
            if (info.isPreCondition) {
                this.$Api.exam.getExamByExamId(info.chapterType, info.examId).then(res => {
                    this.examInfo = res.data.data;
                    this.testStep = 2;
                }).catch(() => { })
            } else {
                this.$Dialog.toast('请先完成下面的章节测试', { type: 'warning' });
                return
            }
        }
    },
};
</script>
<style lang="scss" scoped>
.test_exam {
    width: 762px;
    padding: 15px 20px;
    box-sizing: border-box;
    background: #FFFFFF;
    border-radius: 10px;

    .test_top {
        // font-weight: bold;
        font-size: 22px;
        color: #111111;

        .back_icon {
            width: 28px;
            height: 28px;
        }

        .back_text {
            font-size: 14px;
            color: #13D6AA;
            margin-left: 7px;
        }
    }

    .test_top2 {
        font-size: 18px;
    }

    .test_content {
        .test_content_one {
            margin-top: 15px;

            .test_title {
                // font-weight: bold;
                font-size: 18px;
                color: #111111;
            }

            .test_info {
                margin-top: 15px;
                width: 721px;
                height: 56px;
                background: #F8F9FB;
                border-radius: 10px;
                padding: 0 20px;
                box-sizing: border-box;

                .test_name {
                    // font-weight: 600;
                    color: #333333;
                    margin: 0 15px 0 10px;
                }

                .test_deadline {
                    font-size: 14px;
                    color: #999999;
                }

                .test_info_right {
                    .test_score {
                        font-size: 14px;
                        color: #999999;

                        .score_value {
                            color: RGBA(93, 221, 188, 1);
                        }
                    }

                    .btn_test {
                        width: 90px;
                        height: 32px;
                        background: linear-gradient(90deg, #00D5C2, #00D498);
                        border-radius: 16px;
                        line-height: 32px;
                        text-align: center;
                        color: #FFFFFF;
                        margin-left: 20px;
                        font-weight: normal;
                        font-size: 16px;
                    }
                }
            }

            .test_detail {
                margin-top: 15px;
                padding-left: 40px;
                box-sizing: border-box;

                .test_score_info {
                    font-size: 14px;
                    color: #999999;
                }

                .test_detail_one {
                    margin-top: 15px;
                    font-size: 14px;
                    color: #333333;

                    .test_label {
                        width: 120px;
                    }

                    .active_score {
                        color: RGBA(93, 221, 188, 1);
                    }
                }

                .test_attention {
                    color: #999999;
                    margin-top: 10px;
                }

                .history_test {
                    margin-top: 15px;
                    width: 658px;
                    // height: 115px;
                    border-radius: 10px;
                    border: 1px solid #DDDDDD;

                    .history_test_top {
                        // font-weight: bold;
                        color: #333333;
                        text-align: center;
                        line-height: 37px;
                        background: #F8F8F8;

                        .test_num {
                            width: 160px;
                        }

                        .test_time {
                            width: 200px;
                        }

                        .test_score {
                            width: 160px;
                        }
                    }

                    .history_test_content {
                        border-top: 1px solid rgba(221, 221, 221, 1);
                        background: #FDFED1;
                        color: #FF6619;
                        font-size: 14px;

                        .test_look {
                            color: #13D6AA;
                        }
                    }
                }
            }
        }
    }

    .test_info {
        margin-top: 15px;
        width: 721px;
        height: 80px;
        background: #FEFED1;
        border-radius: 10px;
        padding: 15px 20px;
        box-sizing: border-box;
        color: #333333;
        // font-weight: 600;

        .active_text {
            color: rgba(255, 62, 3, 1);
            font-size: 18px;
        }
    }

    .attention_box {
        margin-top: 15px;

        .attention_text {
            font-size: 16px;
            color: #999999;
            line-height: 30px;
        }
    }

    .agree_box {
        margin-top: 20px;
        font-weight: bold;
        color: #666666;

        .select_none_icon {
            width: 20px;
            height: 20px;
            margin-right: 4px;
        }
    }

    .btn_test {
        // margin-top: 20px;
        width: 100px;
        height: 34px;
        background: linear-gradient(90deg, #00D5C2, #00D498);
        border-radius: 17px;
        line-height: 34px;
        text-align: center;
        color: #FFFFFF;
        font-weight: normal;
        font-size: 16px;
    }
}
</style>